/* Fence calculator assumptions — SINGLE SOURCE, Josh-approved 12 Jul 2026.
   Clips are PER-MESH: one clip per horizontal wire per picket (a flat 8 would
   under-quote exclusion jobs by half). Wire count parses automatically from the
   mesh name ("Hinged Joint 8/90/30" -> 8, "Fixed Knot 16/180/15" -> 16); add an
   entry to wires_overrides ONLY if a name ever fails to parse. Edit here only. */
window.OB_CALC = {
  approved: true,
  spacing_default_m: 4,
  spacing_min_m: 2,
  spacing_max_m: 10,
  clip_box_size: 10000,
  clip_box_price: 250,
  wires_overrides: {},
  bulk_nudge_at: 200,
  corners_note: '{n} corners/ends typically need {n} strainer assemblies — not included in this total. Call Daryl to spec them.',
  advisory: "This estimate covers mesh, pickets and clips at your chosen spacing. Gates, strainers, corner assemblies, terrain and delivery will change what you actually need — rolls are rounded up, so you'll have offcut, not a shortfall. Factory pickup is standard. Need delivery? Daryl quotes it before payment; fencing orders of $10,000+ inc GST may qualify for free delivery within 500km by road."
};
